import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';

/**
 * Admin dashboard snapshot. Callables only — no client Firestore reads.
 */
export async function getAdminDashboardSummary() {
  const fn = httpsCallable(functions, 'getAdminDashboardSummary');
  const { data } = await fn({});
  return data;
}
